import { Link } from './Link';
import { usePeek, peekRoute, type PeekType } from '../hooks/usePeek';

export function PeekLink({
  type,
  id,
  className,
  children,
  title,
}: {
  type: PeekType;
  id: string;
  className?: string;
  children: React.ReactNode;
  title?: string;
}) {
  const { openPeek } = usePeek();
  return (
    <Link
      to={peekRoute(type, id)}
      className={className}
      title={title}
      onClick={(e) => {
        // Let cmd/ctrl/shift/alt/middle-click fall through to the real route
        // (native new-tab); plain left-click opens the peek dialog.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        openPeek(type, id);
      }}
    >
      {children}
    </Link>
  );
}
